<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">

      <div class="l-main-head">

        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">配信グループの一覧</div>
        </div>

        <a class="c-btn c-btn--blue u-w250" href="/coins-admin/message-group/add">
          <div class="c-icon c-icon--white u-wh18 c-icon--alpha70">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#edit" />
            </svg>
          </div>
          <p class="c-btn__text">配信グループの作成</p>
        </a>
      </div>

      <div class="l-main-content">
        <div class="p-message-result">
          <div class="p-message-search">
            <form action="/" method="get" @submit.prevent>
              <div class="p-message-search-keyword">
                <div class="c-input u-w400">
                  <input
                    v-model="groupName"
                    class="c-input__item c-input__item--overlay-ico"
                    type="text"
                    name="group_name"
                    value=""
                    placeholder="グループ名で検索"
                  />
                  <div class="c-input__icon c-input__icon--overlay" @click="onSearchClick($event)">
                    <div class="c-icon c-icon--white u-wh30">
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use xlink:href="/assets/img/sprite.svg#search" />
                      </svg>
                    </div>
                  </div>
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="p-message-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信グループが存在しません</div>
            </div>
            <table class="c-table">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w100 is-sortable" style="padding: 15px !important;">
                    <span class="c-table__text">グループ名</span>
                    <sort-switch name="group_name" :order="sortTargets.group_name" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">紐付いているメッセージ件数</span>
                    <sort-switch name="relational_message_count" :order="sortTargets.relational_message_count" @on-click="onClickSortButton($event)" />
                  </th>
                </tr>
              </thead>

              <!-- 配信グループリスト -->
              <message-group-list-item
                v-for="(messageGroup, index) in messageGroups.data"
                :key="index"
                :message-group="messageGroup"
                :message-group-info="messageGroupInfo"
                @delete-click="onDeleteGroup"
                @edit-click="onEditGroup"
              />
              <!-- /配信グループリスト -->
            </table>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>

        </div>
      </div>
    </main>

    <!-- モーダル: 削除確認 -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--message-delete"
      title="以下のグループを削除してもよろしいですか? ※ 現在紐付いているメッセージのグループが解除されます"
      :body="`グループ : ${currentGroupName} / 紐付いている件数 : ${currentGroupRelationalMessageCount}`"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteGroup
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModal"
    />

  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    // csrfToken: String,
    messageGroupInfo: Object,
  },
  data () {
    return {
      currentGroupId: null,
      currentGroupName: null,
      currentGroupRelationalMessageCount: 0,

      messageGroups: [],
      groupName: null,
      sortTargets: {
        group_name: 0,
        relational_message_count: -1,
      },
      currentSortTarget: null,
      currentSortOrder: null,

      // フラグ系
      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      isDeleteGroup: false,
      errorMessage: '',

      paginationInfo: null,
      page: 1,
      searchConditionCache: null
    }
  },
  mounted: function() {
    this.loadData();
  },
  methods: {
    loadData: function(useCache) {
      useCache = useCache || false;

      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0) {
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメーター作成
      let params = {
        params: {
          groupName: this.groupName,
          relational_message_count: this.relational_message_count,
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      }

      if (useCache) {
        // ページ情報のみ変更
        params = JSON.parse(JSON.stringify(this.searchConditionCache));
        params.params.page = this.page;
      } else {
        this.searchConditionCache = params;
      }

      this.isLoading = true;
      this.isLoaded = false;

      // 配信グループデータの取得処理実行
      axios.get('/api/message-group/list', params)
        .then(res => {
          this.messageGroups = res.data.messageGroups;
          this.paginationInfo = res.data.messageGroups;
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            this.isEmpty = (res.data.messageGroups.data.length < 1);
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = '配信メッセージ一覧の取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: メッセージリストのソートボタンクリック
    onClickSortButton: function(target) {
      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

    // 検索ボタンクリック
    onSearchClick: function(event) {
      event.preventDefault();
      this.page = 1;
      this.loadData();
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 配信グループの編集ボタン
    onEditGroup: function(groupId) {
      location.href = this.messageGroupInfo.editUrl + '?group_id=' + groupId;
    },

    // クリック: 配信グループの削除ボタン
    onDeleteGroup: function(group) {
      this.currentGroupId = group.group_id;
      this.currentGroupName = group.group_name;
      this.currentGroupRelationalMessageCount = group.relational_message_count;
      this.isDeleteGroup = true;
    },

    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false;
      this.errorMessage = '';
    },

    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteGroup = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    // クリック: 操作モーダルのENTER処理
    onEnterConrolModal() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refControlModal.showLoader();

      // パラメーター作成
      const params = {
        group_id: this.currentGroupId,
      };

      // 削除処理実行
      axios.post('/api/message-group/delete', params)
        .then(_res => {
          this.$refs.refControlModal.hideLoader();
          this.isDeleteGroup = false;
          this.errorMessage = ''
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          this.$refs.refControlModal.hideLoader();
          this.$refs.refControlModal.showErrorMessage('メッセージの削除に失敗しました');
          this.handleHttpError(error);
        });
    },

    // ページネーションボタンクリック処理
    // ページネーションコンポーネントからキックされる
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.loadData(true);
    },

  }

}
</script>
